var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{attrs:{"to":{ name: _vm.central }}},[_c('Logo',{staticStyle:{"fill":"white","width":"130px","vertical-align":"middle"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }